module.exports = __webpack_public_path__ + "img/certificate-CU-foundation.becdc362.jpg";